// src/data/exercises/L5_01.js

const accountOptions = [
  '現金', '売掛金', '貸倒引当金', '売上', '貸倒損失'];

export const L5_01 = {
  title: '簿記　3級（第214-1回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
      content: {
       parts: [
    { "type": "ruby", "text": "得意先", "ruby": "とくいさき" },
    { "type": "text", "value": "に" },
    { "type": "ruby", "text": "対", "ruby": "たい" },
    { "type": "text", "value": "する" },
    { "type": "ruby", "text": "売掛金", "ruby": "うりかけきん" },
    { "type": "text", "value": "￥80,000を" },
    { "type": "ruby", "text": "現金", "ruby": "げんきん" },
    { "type": "text", "value": "で" },
    { "type": "ruby", "text": "回収", "ruby": "かいしゅう" },
    { "type": "text", "value": "した。" }
],
      },
      table: {
        options: accountOptions,
      },
      answer: [
        { debitAccount: '現金', debitAmount: 80000, creditAccount: '売掛金', creditAmount: 80000 },
      ],

      // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {
        parts: [
          { type: 'text', value: '「現金で回収した」は現金をもらうので\n' },
          { type: 'styled', value: '①現金の増加（プラス）借方（左・Ｄｒ）です。\n\n', color: 'red', bold: true },
          { type: 'text', value: '「売掛金を回収」なので、\n' },
          { type: 'styled', value: '②売掛金が減少（マイナス）貸方（右・Ｃｒ）です。', color: 'red', bold: true },
        ]
      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`「現金で回収した」は現金をもらうので
①	現金が増加（プラス）します。

「売掛金を回収」なので、
②	売掛金が減少（マイナス）します。
`,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {
          parts: [
          { type: 'text', value: '「現金で回収した」は現金をもらうので\n' },
          { type: 'styled', value: '①現金の増加（プラス）借方（左・Ｄｒ）です。\n\n', color: 'red', bold: true },
          { type: 'text', value: '「売掛金を回収」なので、\n' },
          { type: 'styled', value: '②売掛金が減少（マイナス）貸方（右・Ｃｒ）です。', color: 'red', bold: true },
        ]
          }
        ],
       
        
      },
    },
  ],
};